/**
 * Modify links on page load.
 */
H_Tools?.link_tools?.modifyLinks(document);
